import { Navigate, useParams } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function InviteRedirect() {
  usePageMeta("Invite — Shattara AI", "", { noIndex: true });
  const { code } = useParams<{ code: string }>();
  return <Navigate to={`/auth/signup?ref=${code || ""}`} replace />;
}
